import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface CustomAlertDialogProps {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
  onAgree?: () => void;
  agreeText?: string;
  disagreeText?: string;
}

const CustomAlertDialog: React.FC<CustomAlertDialogProps> = ({
  open,
  title,
  content,
  onClose,
  onAgree,
  agreeText = 'Agree',
  disagreeText = 'Disagree',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{disagreeText}</Button>
        <Button onClick={onAgree || onClose} autoFocus>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomAlertDialog; 